import { Injectable } from '@angular/core';

import { AuthStore } from '@store';
import { EquipmentMockApi } from '@vi-iot/client/apis/equipment/equipment.mock.api';
import { BaseApiPickerImpl } from '../base.api-picker';

import { EquipmentApi } from './equipment.api';

@Injectable({ providedIn: 'root' })
export class EquipmentApiPicker extends BaseApiPickerImpl<EquipmentApi | EquipmentMockApi> {
  constructor(
    protected authStore: AuthStore,
    protected realApi: EquipmentApi,
    protected mockApi: EquipmentMockApi
  ) {
    super(authStore, realApi, mockApi);
  }

  // override not working with pretier -> TODO
  // override instance(): EquipmentApi | EquipmentMockApi {
  instance(): EquipmentApi | EquipmentMockApi {
    return this.authStore.isDemoSync ? this.mockApi : this.realApi;
  }
}
